import React from 'react';
import { Badge } from 'react-bootstrap';

const StatusBadge = ({ status, className = '', ...props }) => {
  const getStatusConfig = (status) => {
    const configs = {
      published: {
        variant: 'success',
        text: 'Publicado',
        icon: 'las la-check-circle'
      },
      pending: {
        variant: 'warning',
        text: 'Aguardando Aprovação',
        icon: 'las la-clock'
      },
      suspended: {
        variant: 'secondary',
        text: 'Suspenso',
        icon: 'las la-pause-circle'
      },
      removed: {
        variant: 'danger',
        text: 'Removido',
        icon: 'las la-times-circle'
      },
      rejected: {
        variant: 'danger',
        text: 'Rejeitado',
        icon: 'las la-exclamation-circle'
      }
    };

    return configs[status] || {
      variant: 'secondary',
      text: status || 'Desconhecido',
      icon: 'las la-question-circle'
    };
  };

  const config = getStatusConfig(status);

  return (
    <Badge 
      bg={config.variant} 
      className={`marketplace-status-badge marketplace-status-${status} d-flex align-items-center ${className}`}
      {...props}
    >
      <i className={`${config.icon} me-1`} style={{ fontSize: '14px' }} />
      {config.text}
    </Badge>
  );
};

export default StatusBadge;